import React from 'react';
import { Checkbox, makeStyles } from '@material-ui/core';
import { MDSTheme, MDSTypography } from '@marqvision/mds/core';
import { useLanguage } from '~/hooks';
import { useGlobalAction } from '~/hooks';

const useStyles = makeStyles(() => ({
  root: {
    padding: '12px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    marginTop: '20px',
    gap: '12px',
  },
  checkbox: {
    padding: 0,
    alignSelf: 'flex-start',
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  link: { textDecoration: 'none' },
}));

interface IProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const ConsentBox = ({ checked, onChange }: IProps): JSX.Element => {
  const classes = useStyles();
  const { Lang } = useLanguage();
  const { showPolicy } = useGlobalAction();

  return (
    <div
      className={classes.root}
      style={{
        backgroundColor: checked ? MDSTheme.palette.blue[50] : MDSTheme.palette.bluegray[50],
      }}
    >
      <Checkbox checked={checked} color="primary" disableRipple className={classes.checkbox} onChange={onChange} />
      <MDSTypography variant="T14" weight="medium" style={{ color: MDSTheme.palette.bluegray[800] }}>
        {Lang.Consent(
          () => showPolicy('terms'),
          () => showPolicy('privacy')
        )}
      </MDSTypography>
    </div>
  );
};

export default ConsentBox;
